import { Button } from './button';

type TButtonVariant =
  | 'link'
  | 'default'
  | 'success'
  | 'insurance'
  | 'destructive'
  | 'outline'
  | 'secondary'
  | 'ghost'
  | 'ghostIcon'
  | 'icon'
  | 'completed'
  | 'sheet'
  | null;

export const ToasterContent = ({
  toast,
  title,
  description,
  buttonVariant,
}: {
  toast: any;
  title?: string;
  description?: string;
  buttonVariant?: TButtonVariant;
}) => {
  return (
    <div className="vai-flex vai-flex-row vai-gap-16 vai-w-full vai-items-center">
      <div className="vai-flex vai-flex-col vai-gap-2">
        <span className="vai-typography-h5 vai-text-black">{title}</span>
        <span className="vai-typography-xs vai-text-gray-500">
          {description}
        </span>
      </div>
      <Button
        variant={buttonVariant}
        size="sm"
        onClick={() => {
          toast.dismiss();
        }}
      >
        Got it
      </Button>
    </div>
  );
};
